export default __webpack_public_path__ + "static/media/AFM_rond_risicoscore1.ff0c5c19.jpg";